module.exports = __webpack_public_path__ + "static/prep-card-02fb0899e8ea6bdea1fcfbfc1daefbf1.png";